export default "__VITE_ASSET__C6LWff1l__"